import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { utils } from "xlsx-js-style";
export var groupReportMonthsByYear = function(months) {
    var groups = [];
    months.forEach(function(month) {
        var last = groups[groups.length - 1];
        if ((last === null || last === void 0 ? void 0 : last.year) === month.year) last.count += 1;
        else groups.push({
            year: month.year,
            count: 1
        });
    });
    return groups;
};
export var getBrandMonthTotal = function(brand, monthKey) {
    if (brand.totals && Object.prototype.hasOwnProperty.call(brand.totals, monthKey)) {
        return Number(brand.totals[monthKey] || 0);
    }
    return brand.products.reduce(function(sum, product) {
        return sum + Number(product.quantities[monthKey] || 0);
    }, 0);
};
var quantityWithShopCount = function(quantity, shopCount, showShopCount) {
    if (!showShopCount) return quantity === 0 ? "" : quantity;
    var quantityText = quantity === 0 ? "" : quantity.toLocaleString("en-US");
    return "".concat(quantityText, "\nจำนวนร้านค้า: ").concat(Number(shopCount || 0).toLocaleString("en-US"));
};
export var buildSkuActualDeliveryWorksheet = function(report) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_showShopCount = _ref.showShopCount, showShopCount = _ref_showShopCount === void 0 ? false : _ref_showShopCount, _ref_showBrandSequence = _ref.showBrandSequence, showBrandSequence = _ref_showBrandSequence === void 0 ? false : _ref_showBrandSequence;
    var _report_branches;
    var rows = [
        [
            "#",
            "PRODUCT"
        ].concat(_to_consumable_array(report.months.map(function(month) {
            return month.year;
        }))),
        [
            "",
            ""
        ].concat(_to_consumable_array(report.months.map(function(month) {
            return month.month;
        })))
    ];
    var reportGroups = ((_report_branches = report.branches) === null || _report_branches === void 0 ? void 0 : _report_branches.length) ? report.branches : report.brands;
    reportGroups.forEach(function(brand, groupIndex) {
        var groupName = brand.shop_name ? "ร้านค้า: ".concat(brand.shop_name, " | สาขา: ").concat(brand.branch_name || "NO BRANCH") : brand.brand_name || "NO BRAND";
        rows.push([
            brand.shop_name || showBrandSequence ? groupIndex + 1 : "",
            groupName
        ].concat(_to_consumable_array(report.months.map(function() {
            return "";
        }))));
        brand.products.forEach(function(product, productIndex) {
            rows.push([
                productIndex + 1,
                product.product_name
            ].concat(_to_consumable_array(report.months.map(function(month) {
                var _product_shop_counts;
                var quantity = Number(product.quantities[month.key] || 0);
                return quantityWithShopCount(quantity, (_product_shop_counts = product.shop_counts) === null || _product_shop_counts === void 0 ? void 0 : _product_shop_counts[month.key], showShopCount);
            }))));
        });
        rows.push([
            "",
            "TOTAL"
        ].concat(_to_consumable_array(report.months.map(function(month) {
            var _brand_shop_counts;
            var quantity = getBrandMonthTotal(brand, month.key);
            if (!showShopCount) return quantity;
            return quantityWithShopCount(quantity, (_brand_shop_counts = brand.shop_counts) === null || _brand_shop_counts === void 0 ? void 0 : _brand_shop_counts[month.key], showShopCount);
        }))));
    });
    var worksheet = utils.aoa_to_sheet(rows);
    worksheet["!merges"] = [
        {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 1,
                c: 0
            }
        },
        {
            s: {
                r: 0,
                c: 1
            },
            e: {
                r: 1,
                c: 1
            }
        }
    ];
    var monthColumn = 2;
    groupReportMonthsByYear(report.months).forEach(function(group) {
        if (group.count > 1) {
            worksheet["!merges"].push({
                s: {
                    r: 0,
                    c: monthColumn
                },
                e: {
                    r: 0,
                    c: monthColumn + group.count - 1
                }
            });
        }
        monthColumn += group.count;
    });
    worksheet["!cols"] = [
        {
            wch: 7
        },
        {
            wch: 55
        }
    ].concat(_to_consumable_array(report.months.map(function() {
        return {
            wch: 12
        };
    })));
    if (showShopCount) {
        Object.keys(worksheet).forEach(function(cellAddress) {
            if (!cellAddress.startsWith("!")) {
                worksheet[cellAddress].s = _object_spread_props(_object_spread({}, worksheet[cellAddress].s || {}), {
                    alignment: {
                        wrapText: true,
                        vertical: "center"
                    }
                });
            }
        });
    }
    return worksheet;
};
var border = {
    top: {
        style: "thin",
        color: {
            rgb: "FF666666"
        }
    },
    bottom: {
        style: "thin",
        color: {
            rgb: "FF666666"
        }
    },
    left: {
        style: "thin",
        color: {
            rgb: "FF666666"
        }
    },
    right: {
        style: "thin",
        color: {
            rgb: "FF666666"
        }
    }
};
var centered = {
    horizontal: "center",
    vertical: "center",
    wrapText: true
};
export var buildSkuGiftBranchWorksheet = function(report) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_heading = _ref.heading, heading = _ref_heading === void 0 ? "ร้านค้าที่เบิกของแถม (จำนวน ชิ้น)" : _ref_heading;
    var branches = report.branches || [];
    var rows = [
        [
            "รายการสินค้า",
            "",
            heading
        ].concat(_to_consumable_array(branches.map(function() {
            return "";
        }))),
        [
            "",
            "",
            "TOTAL"
        ].concat(_to_consumable_array(branches.map(function(branch) {
            return branch.label;
        })))
    ];
    var detailRows = [];
    var brandRows = [];
    (report.brands || []).forEach(function(brand) {
        brandRows.push(rows.length);
        rows.push([
            "",
            brand.brand_name || "NO BRAND",
            ""
        ].concat(_to_consumable_array(branches.map(function() {
            return "";
        }))));
        (brand.products || []).forEach(function(product) {
            detailRows.push(rows.length);
            rows.push([
                product.barcode || "",
                product.product_name || "-",
                Number(product.total || 0)
            ].concat(_to_consumable_array(branches.map(function(branch) {
                var _product_branch_quantities;
                return Number(((_product_branch_quantities = product.branch_quantities) === null || _product_branch_quantities === void 0 ? void 0 : _product_branch_quantities[branch.key]) || 0);
            }))));
        });
    });
    var totalRow = rows.length;
    rows.push([
        "",
        "TOTAL",
        Number(report.grand_total || 0)
    ].concat(_to_consumable_array(branches.map(function(branch) {
        var _report_branch_totals;
        return Number(((_report_branch_totals = report.branch_totals) === null || _report_branch_totals === void 0 ? void 0 : _report_branch_totals[branch.key]) || 0);
    }))));
    var worksheet = utils.aoa_to_sheet(rows);
    worksheet["!merges"] = [
        {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 1,
                c: 1
            }
        },
        {
            s: {
                r: 0,
                c: 2
            },
            e: {
                r: 0,
                c: branches.length + 2
            }
        }
    ];
    worksheet["!cols"] = [
        {
            wch: 19
        },
        {
            wch: 58
        },
        {
            wch: 14
        }
    ].concat(_to_consumable_array(branches.map(function() {
        return {
            wch: 24
        };
    })));
    worksheet["!rows"] = [
        {
            hpt: 28
        },
        {
            hpt: 30
        }
    ];
    var range = utils.decode_range(worksheet["!ref"]);
    for(var row = range.s.r; row <= range.e.r; row += 1){
        for(var col = range.s.c; col <= range.e.c; col += 1){
            var address = utils.encode_cell({
                r: row,
                c: col
            });
            if (!worksheet[address]) worksheet[address] = {
                t: "s",
                v: ""
            };
            worksheet[address].s = {
                border: border,
                alignment: col === 1 && row > 1 ? {
                    vertical: "center",
                    wrapText: true
                } : centered
            };
        }
    }
    for(var col1 = 0; col1 <= branches.length + 2; col1 += 1){
        var topCell = worksheet[utils.encode_cell({
            r: 0,
            c: col1
        })];
        topCell.s = _object_spread_props(_object_spread({}, topCell.s), {
            fill: {
                fgColor: {
                    rgb: col1 < 2 ? "FFFFFFFF" : "FFD9EAD3"
                }
            },
            font: {
                bold: true,
                sz: 13
            }
        });
        var secondCell = worksheet[utils.encode_cell({
            r: 1,
            c: col1
        })];
        secondCell.s = _object_spread_props(_object_spread({}, secondCell.s), {
            fill: {
                fgColor: {
                    rgb: col1 < 2 ? "FFFFFFFF" : "FFF4CCCC"
                }
            },
            font: {
                bold: true
            }
        });
    }
    brandRows.forEach(function(row) {
        for(var col = 0; col <= branches.length + 2; col += 1){
            var cell = worksheet[utils.encode_cell({
                r: row,
                c: col
            })];
            cell.s = _object_spread_props(_object_spread({}, cell.s), {
                fill: {
                    fgColor: {
                        rgb: "FFD9D9D9"
                    }
                },
                font: {
                    bold: col === 1
                }
            });
        }
    });
    detailRows.forEach(function(row) {
        for(var col = 3; col <= branches.length + 2; col += 1){
            var cell = worksheet[utils.encode_cell({
                r: row,
                c: col
            })];
            if (Number(cell.v || 0) > 1) {
                cell.s = _object_spread_props(_object_spread({}, cell.s), {
                    font: {
                        color: {
                            rgb: "FFFF0000"
                        }
                    }
                });
            }
        }
    });
    for(var col2 = 0; col2 <= branches.length + 2; col2 += 1){
        var cell = worksheet[utils.encode_cell({
            r: totalRow,
            c: col2
        })];
        cell.s = _object_spread_props(_object_spread({}, cell.s), {
            fill: {
                fgColor: {
                    rgb: "FFD9D9D9"
                }
            },
            font: {
                bold: true,
                color: {
                    rgb: "FF000000"
                }
            }
        });
    }
    return worksheet;
};
